import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { useSlotGroup } from '@vibesites/runtime/react';
import { EditableSlotGroup, RichTextContent } from '@vibesites/runtime/react';
import { VibesitesImage } from '@vibesites/ui-primitives';

const bgImageDef: SlotGroupDefinition = {
  label: 'Background Image',
  fields: {
    image: { label: 'Image', type: 'image', defaultField: 'property_featured_image' },
    alt: { label: 'Alt Text', type: 'text', defaultValue: 'FAQ banner' },
  },
};

export function FAQHero() {
  const bgImage = useSlotGroup('faqhero.bg_image', bgImageDef);

  return (
    <section className="relative h-[42vh] min-h-[300px] max-h-[420px] overflow-hidden">
      <EditableSlotGroup
        groupPath="faqhero.bg_image"
        definition={bgImageDef}
        className="absolute inset-0"
      >
        {bgImage.image ? (
          <VibesitesImage
            url={bgImage.image}
            alt={bgImage.alt || 'FAQ banner'}
            sizes="100vw"
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full bg-[var(--vibe-color-text)]" />
        )}
        <div className="absolute inset-0 bg-black/40" />
      </EditableSlotGroup>

      <div
        className="relative z-10 flex flex-col items-center justify-center h-full text-center text-white px-4"
        style={{ paddingTop: 'calc(var(--offer-banner-height, 0px) + 72px)' }}
      >
        <RichTextContent
          path="faqhero.title"
          as="h1"
          className="font-heading text-3xl sm:text-4xl md:text-5xl font-normal mb-3 uppercase tracking-wider"
        />
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'FAQHero',
  displayName: 'FAQ Hero',
  tokens: {
    'faqhero.title': {
      label: 'Title',
      type: 'richtext',
      defaultValue: '<p>Frequently Asked Questions</p>',
    },
  },
  slotGroups: {
    'faqhero.bg_image': {
      label: 'Background Image',
      fields: {
        image: { label: 'Image', type: 'image', defaultField: 'property_featured_image' },
        alt: { label: 'Alt Text', type: 'text', defaultValue: 'FAQ banner' },
      },
    },
  },
};

(FAQHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default FAQHero;
